import ButtonsWidget from '@plone/volto/components/manage/Widgets/ButtonsWidget';
import { defineMessages, useIntl } from 'react-intl';

import textAlignCenterSVG from './icons/text-align-center.svg';
import textAlignLeftSVG from './icons/text-align-left.svg';
import textAlignRightSVG from './icons/text-align-right.svg';

const messages = defineMessages({
  left: {
    id: 'Text Align Left',
    defaultMessage: 'Left',
  },
  right: {
    id: 'Text Align Right',
    defaultMessage: 'Right',
  },
  center: {
    id: 'Text Align Center',
    defaultMessage: 'Center',
  },
});

const TextAlignWidget = (props) => {
  const intl = useIntl();

  const actions = ['left', 'center', 'right'];

  const actionsInfo = {
    left: [textAlignLeftSVG, intl.formatMessage(messages.left)],
    center: [textAlignCenterSVG, intl.formatMessage(messages.center)],
    right: [textAlignRightSVG, intl.formatMessage(messages.right)],
  };

  return (
    <ButtonsWidget
      {...props}
      actions={actions}
      actionsInfoMap={actionsInfo}
      defaultAction={props.defaultAction || 'left'}
    />
  );
};

export default TextAlignWidget;
